<template>
  <div class="core">
    <div class="layui-fluid">
      <div>
        <div class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div class="layui-form-item">
            <div class="layui-inline">角色编号</div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_role.queryObject['ROLECODE:2']"
                placeholder="请输入角色编号"
              />
            </div>
            <div class="layui-inline">角色名</div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_role.queryObject['ROLENAME:2']"
                placeholder="请输入角色名"
              />
            </div>
            <div class="layui-inline">
              <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_role.load()" title="查询">查询</button>
              <button class="layui-btn" @click="$refs.t_role.reset()" title="重置">重置</button>
            </div>
          </div>
        </div>
        <div class="layui-card-body">
          <div class="ywpt-btn">
            <button
              class="layui-btn layuiadmin-btn-role"
              :class="{ 'layui-btn-disabled': t_role.checkedRows.length < 1 }"
              @click="$refs.t_role.delCheckedRows()"
            >
              删除
            </button>
            <button
              class="layui-btn layuiadmin-btn-role"
              @click="
                $refs.roleForm.openWin()
                $refs.roleForm.setEditRow()
              "
            >
              添加
            </button>
          </div>
          <div class="layui-table-body layui-table-main">
            <layui-table
              ref="t_role"
              table-name="DB_ROLE"
              :sort="['ROLEID:DESC']"
              :page-size="15"
              :page-range="6"
              :page-options="[15, 25, 50, 100]"
              select-fields="ROLEID,ROLECODE,ROLEDESC,ROLENAME,FUNCTION_IDS"
              @table-event-detail="
                $refs.roleForm.openWin()
                $refs.roleForm.setEditRow($event.data)
              "
              @table-event-edit="
                $refs.roleForm.openWin('编辑')
                $refs.roleForm.setEditRow($event.data)
              "
              @table-event-del="$refs.t_role.delRows($event.data)"
              height="full-270"
            >
              <div>
                <!-- 开启复选框 -->
                <div checkbox="true" fixed="left"></div>
                <!-- <div field="_NUMBER" title="序号" width="60"></div> -->
                <div field="ROLECODE" title="角色编号"></div>
                <div field="ROLENAME" title="角色名"></div>
                <div field="ROLEDESC" title="角色描述"></div>
                <div fixed="right" width="150" align="center" toolbar title="操作">
                  <script type="text/html">
                    <a class="layui-btn-xs" lay-event="detail">查看</a>
                    <a class="layui-btn-xs" lay-event="edit">编辑</a>
                    <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
        </div>

        <layui-form ref="roleForm" :default-value="{ STATE: 1 }">
          <template slot-scope="{ scope }">
            <div class="layui-form" style="padding: 20px 30px 0 0">
              <div class="layui-form-item">
                <label class="layui-form-label"> <span class="x-red">*</span>角色编号：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.ROLECODE"
                    placeholder="请输入角色编号"
                    autocomplete="off"
                    class="layui-input"
                    name="ROLECODE"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> <span class="x-red">*</span>角色名：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.ROLENAME"
                    placeholder="请输入角色名"
                    autocomplete="off"
                    class="layui-input"
                    name="ROLENAME"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> <span class="x-red">*</span>权限信息：</label>
                <div class="layui-input-inline">
                  <div style="border: 1px rgb(210, 210, 210) solid; border-radius: 8px; width: 380px; overflow: auto">
                    <layui-tree
                      v-model="scope.editRow.FUNCTION_IDS"
                      table-name="DB_FUNCTION"
                      text-field="FUNCTIONNAME"
                      value-field="FUNCTIONID"
                      id-field="FUNCTIONID"
                      parent-field="PID"
                      :init-expand-level="1"
                      :condition="{}"
                      :show-check="true"
                    ></layui-tree>
                  </div>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> <span class="x-red">*</span>角色描述：</label>
                <div class="layui-input-inline">
                  <textarea
                    placeholder="请输入角色描述"
                    v-model="scope.editRow.ROLEDESC"
                    style="width: 380px"
                    class="layui-textarea"
                  ></textarea>
                </div>
              </div>

              <div class="layui-form-item">
                <label for="L_repass" class="layui-form-label"> </label>
                <button class="layui-btn" @click="$refs.roleForm.save(t_role)">保存</button>
                <button class="layui-btn" @click="$refs.roleForm.close()">关闭</button>
              </div>
            </div>
          </template>
        </layui-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Role',
  data() {
    return {
      t_role: {
        checkedRows: 0,
        queryObject: {},
      },
    }
  },
  mounted() {
    this.t_role = this.$refs.t_role
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/role/Role.vue